export const _routes = [
  { title: "Home", route: "/", icon: "home" },
  { title: "Docx Templates", route: "/templates", icon: "publish" },
  { title: "HTML Templates", route: "/htmlTemplates", icon: "publish" },
  // { title: "Json Templates", route: "/jsonTemplates", icon: "publish" },
  { title: "Document Suite", route: "/document-suite", icon: "publish" },
  { title: "Configuration", route: "/document-suite/configurations", icon: "publish" },
  { title: "E-Sign", route: "/e-sign", icon: "email" },
];

export const _administrator = [
  { title: "View Clients", route: "/viewClients", icon: "View Clients"},
  { title: "Add Custom Field", route: "/addCustomField", icon: "Custom Fields"},
  { title: "RAG Dashboard", route: "/rag/dashboard", icon: "RAG Dashboard"}
];